// extracted by mini-css-extract-plugin
module.exports = {"main_container":"Main_main_container__1k5n7","main":"Main_main__3de2d"};